import { render, staticRenderFns } from "./mfaVerificator.vue?vue&type=template&id=edb4b820&scoped=true"
import script from "./mfaVerificator.vue?vue&type=script&lang=js"
export * from "./mfaVerificator.vue?vue&type=script&lang=js"
import style0 from "./mfaVerificator.vue?vue&type=style&index=0&id=edb4b820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb4b820",
  null
  
)

export default component.exports